import React, { useState } from "react";
import { Box } from "@mui/material";
import { ListaTarefas } from "./ListaTarefas";
import { WizardTarefa } from "./CadastroTarefa/WizardTarefa";
import { DetalhesTarefa } from "./DetalhesTarefa";
import { IBackupTarefaV2 } from "./types";

export const TarefasPage: React.FC = () => {
  const [view, setView] = useState<"lista" | "cadastro">("lista");
  const [tarefaSelecionada, setTarefaSelecionada] = useState<IBackupTarefaV2 | null>(null);
  const [detalhesAberto, setDetalhesAberto] = useState(false);

  const handleVisualizar = (tarefa: IBackupTarefaV2) => {
    setTarefaSelecionada(tarefa);
    setDetalhesAberto(true);
  };

  const handleEditar = (tarefa: IBackupTarefaV2) => {
    // Busca os dados completos da tarefa via API (incluindo senhas mascaradas e sub-propriedades JSON)
    // Para garantir que o formulário tenha todas as informações do banco
    setTarefaSelecionada(tarefa);
    setView("cadastro");
  };

  const handleCriar = () => {
    setTarefaSelecionada(null);
    setView("cadastro");
  };

  const handleSave = () => {
    setView("lista");
    setTarefaSelecionada(null);
  };

  const handleCancel = () => {
    setView("lista");
    setTarefaSelecionada(null);
  };

  return (
    <Box sx={{ p: 1, position: "relative" }}>
      {view === "lista" ? (
        <ListaTarefas
          onVisualizar={handleVisualizar}
          onEditar={handleEditar}
          onCriar={handleCriar}
        />
      ) : (
        <WizardTarefa
          tarefaParaEditar={tarefaSelecionada}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      )}

      <DetalhesTarefa
        tarefa={tarefaSelecionada}
        open={detalhesAberto}
        onClose={() => {
          setDetalhesAberto(false);
          setTarefaSelecionada(null);
        }}
      />
    </Box>
  );
};
